"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ObjectRemoveUndefined_1 = __importDefault(require("../../utils/ObjectRemoveUndefined"));
var MenuFullViewMapper = /** @class */ (function () {
    function MenuFullViewMapper() {
    }
    MenuFullViewMapper.mapToKnownEntities = function (menuFullView) {
        this._reset();
        this._mapCategories(menuFullView.categories);
        this._mapProducts(menuFullView.products);
        this._mapModifierGroups(menuFullView.modifier_groups);
        this._mapModifiers(menuFullView.modifiers);
        this._parseStructure(menuFullView.structure.categories, null);
        return ObjectRemoveUndefined_1.default.remove({
            categories: this._categories,
            products: this._products,
            modifierGroups: this._modifierGroups,
            modifiers: this._modifiers
        });
    };
    MenuFullViewMapper._reset = function () {
        this._categories = {};
        this._products = {};
        this._modifierGroups = {};
        this._modifiers = {};
    };
    MenuFullViewMapper._mapCategories = function (menuCategories) {
        var _this = this;
        for (var menuCategoryId in menuCategories) {
            this._categories[menuCategoryId] = {
                id: menuCategoryId,
                name: menuCategories[menuCategoryId].name,
                description: menuCategories[menuCategoryId].description,
                sort: 0,
                useFirmTimes: false,
                images: menuCategories[menuCategoryId].images.map(function (i) { return _this._mapImage(i); }),
                subcategories: [],
                availabilities: [],
                parent_id: null,
                products: []
            };
        }
    };
    MenuFullViewMapper._mapProducts = function (menuProducts) {
        var _this = this;
        for (var menuProductId in menuProducts) {
            this._products[menuProductId] = {
                id: menuProducts[menuProductId].uuid,
                name: menuProducts[menuProductId].name,
                description: menuProducts[menuProductId].description,
                images: menuProducts[menuProductId].images.map(function (i) { return _this._mapImage(i); }),
                featured: false,
                popular: false,
                sort: 0,
                unitInterval: 1,
                modifierGroups: [],
                price: menuProducts[menuProductId].price / 100,
                vatPrice: menuProducts[menuProductId].price / 100,
                unit: null,
                inStock: menuProducts[menuProductId].in_stock,
                weight: 0,
                extraPoints: 0,
                hasPromotionalPrice: false,
                categoryId: null,
                allergens: []
            };
        }
    };
    MenuFullViewMapper._mapModifierGroups = function (menuModifierGroups) {
        for (var menuModifierGroupId in menuModifierGroups) {
            this._modifierGroups[menuModifierGroupId] = {
                id: menuModifierGroupId,
                name: menuModifierGroups[menuModifierGroupId].name,
                description: menuModifierGroups[menuModifierGroupId].description,
                type: menuModifierGroups[menuModifierGroupId].type,
                isUpsellGroup: menuModifierGroups[menuModifierGroupId].is_upsell_group,
                isRequired: menuModifierGroups[menuModifierGroupId].is_required,
                isMultipleChoice: menuModifierGroups[menuModifierGroupId].is_multiple_choice,
                multipleChoiceMin: menuModifierGroups[menuModifierGroupId].multiple_choice_min,
                multipleChoiceMax: menuModifierGroups[menuModifierGroupId].multiple_choice_max,
                multipleChoiceMultiselectMax: menuModifierGroups[menuModifierGroupId].multiple_choice_multiselect_max,
                multipleChoiceInterval: menuModifierGroups[menuModifierGroupId].multiple_choice_interval,
                sort: menuModifierGroups[menuModifierGroupId].sort,
                modifiers: []
            };
        }
    };
    MenuFullViewMapper._mapModifiers = function (menuModifiers) {
        var _this = this;
        for (var menuModifierId in menuModifiers) {
            this._modifiers[menuModifierId] = {
                id: menuModifierId,
                isDefault: menuModifiers[menuModifierId].is_default,
                isLocked: menuModifiers[menuModifierId].is_locked,
                sort: menuModifiers[menuModifierId].sort,
                inStock: menuModifiers[menuModifierId].in_stock,
                name: menuModifiers[menuModifierId].name,
                description: menuModifiers[menuModifierId].description,
                price: menuModifiers[menuModifierId].price / 100,
                images: (menuModifiers[menuModifierId].images || []).map(function (i) { return _this._mapImage(i); }),
                ingredientType: '',
                type: menuModifiers[menuModifierId].type,
                allergens: menuModifiers[menuModifierId].allergens
            };
        }
    };
    MenuFullViewMapper._parseStructure = function (menuStructureCategories, parentId) {
        for (var categoryId in menuStructureCategories) {
            this._categories[categoryId].subcategories = Object.keys(menuStructureCategories[categoryId].sub_categories || {});
            this._categories[categoryId].products = Object.keys(menuStructureCategories[categoryId].products || {});
            this._categories[categoryId].parent_id = parentId;
            this._parseStructure(menuStructureCategories[categoryId].sub_categories || {}, categoryId);
            this._parseProductInStructure(menuStructureCategories[categoryId].products || {}, categoryId);
        }
    };
    MenuFullViewMapper._parseProductInStructure = function (menuStructureProducts, categoryId) {
        for (var productId in menuStructureProducts) {
            this._products[productId].modifierGroups = Object.keys(menuStructureProducts[productId].modifier_groups || {});
            this._products[productId].categoryId = categoryId;
            this._parseModifierGroupInStructure(menuStructureProducts[productId].modifier_groups || {});
        }
    };
    MenuFullViewMapper._parseModifierGroupInStructure = function (menuStructureModifierGroup) {
        for (var modifierGroupId in menuStructureModifierGroup) {
            this._modifierGroups[modifierGroupId].modifiers = Object.keys(menuStructureModifierGroup[modifierGroupId].modifiers || {});
            this._parseModifierInStructure(menuStructureModifierGroup[modifierGroupId].modifiers || {});
        }
    };
    MenuFullViewMapper._parseModifierInStructure = function (menuStructureModifier) {
        for (var modifierId in menuStructureModifier) {
            this._modifiers[modifierId].modifierGroups = Object.keys(menuStructureModifier[modifierId].modifier_groups || {});
            this._parseModifierGroupInStructure(menuStructureModifier[modifierId].modifier_groups || {});
        }
    };
    MenuFullViewMapper._mapImage = function (inventoryImage) {
        return {
            main: false,
            detail: inventoryImage.path,
            thumb: inventoryImage.path
        };
    };
    MenuFullViewMapper._categories = {};
    MenuFullViewMapper._products = {};
    MenuFullViewMapper._modifierGroups = {};
    MenuFullViewMapper._modifiers = {};
    return MenuFullViewMapper;
}());
exports.default = MenuFullViewMapper;
